// file types
export const IMAGE_TYPES = ["jpg", "gif", "jpeg", "png"];
